__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-identity/v2_16_7/";